const ONE_YEAR_IN_MILLISECONDS = 30758400000; // 1000*60*60*24*356
const DATE_STRING_REGEX = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/; // yyyy-mm-dd

/**
 * @param date a string date in the format yyyy-mm-dd. Example value: 2020-11-14
 * @returns a boolean which will be true only if the time passed since the input date is older than or equal to one year.
 */
export function isOlderThanOrEqualOneYear(date) {
  if (typeof date !== 'string' || !DATE_STRING_REGEX.test(date)) {
    throw new Error(
      'Util function isOlderThanOrEqualOneYear only supports string dates with the format yyyy-mm-dd. This input date ',
      date,
      ' is not supported.'
    );
  }

  let inputDate = new Date(`${date}T00:00:00`);

  let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);

  let numberOfYearsSinceInputDate = (currentDate - inputDate) / ONE_YEAR_IN_MILLISECONDS;

  return numberOfYearsSinceInputDate >= 1;
}
